<div class="p-grid p-align-stretch vertical-container p-px-3 p-mt-0 ops-readiness-container">
  <div class="p-col-12 p-px-0 p-px-md-3">
    <div class="ops-header">
      <div>
        <div class="dropdowns">
          <p-dropdown [(ngModel)]="showSharedEvents" [options]="sharedFilterOptions" (onChange)="refresh()" appendTo="body">
            <ng-template pTemplate="selectedItem" let-selected>
              <div class="flex align-items-center gap-2">
                <i class="pi pi-share-alt"></i>
                <span> Shared: {{ selected.label }} </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <p class="p-mb-1 p-md-sm-0">
          Daily operations readiness for booked, confirmed, and completed events.
          <span *ngIf="loading">Loading... </span>
          <span *ngIf="!loading && dayGroups.length">
            {{ totalEvents }} event{{ totalEvents !== 1 ? 's' : '' }} &middot;
            {{ totalHours | number:'1.1-1' }} hours booked
          </span>
        </p>
      </div>
      <div class="ops-header-actions">
        <ng-container *ngIf="!loading">
          <span *ngIf="lastReload" class="ops-last-updated">Last updated <app-time-since [unixTime]="lastReload"></app-time-since></span>
          <button type="button" class="ops-refresh-button" (click)="refresh()" pTooltip="Refresh" tooltipPosition="bottom" aria-label="Refresh Ops Readiness data">
            <i class="pi pi-refresh ops-refresh-icon" aria-hidden="true"></i>
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="p-col-12">
    <p-blockUI [blocked]="loading" [autoZIndex]="false">
      <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
    </p-blockUI>

    <div *ngIf="!loading && dayGroups.length === 0" class="dashboard-card p-text-center p-p-4">
      <p>No booked, confirmed, or completed events in the selected period.</p>
    </div>

    <div *ngIf="!loading && dayGroups.length" class="ops-accordion-wrapper">
      <div class="ops-accordion-col-headers">
        <span class="ops-accordion-date">Date</span>
        <span class="ops-accordion-count">Events</span>
        <span class="ops-accordion-hours">Hours</span>
        <span class="ops-accordion-revenue">Revenue</span>
        <span class="ops-accordion-days">Days Out</span>
      </div>
      <div *ngFor="let day of dayGroups" class="ops-day-group">
        <div class="ops-day-group__header" (click)="toggleDayExpanded(day.date)">
          <div class="ops-accordion-header">
            <i class="pi" [ngClass]="isDayExpanded(day.date) ? 'pi-chevron-down' : 'pi-chevron-right'" style="margin-right: 0.4rem;"></i>
            <span class="ops-accordion-date">{{ day.displayDate }}</span>
            <span class="ops-accordion-count">{{ day.eventCount }}</span>
            <span class="ops-accordion-hours">{{ day.totalHours | number:'1.1-1' }} hrs</span>
            <span class="ops-accordion-revenue">{{ day.totalRevenue ? (day.totalRevenue | currency:'USD':'symbol':'1.2-2') : '\u2014' }}</span>
            <span class="ops-accordion-days">{{ day.daysUntilMove !== null ? day.daysUntilMove + ' day' + (day.daysUntilMove !== 1 ? 's' : '') : '\u2014' }}</span>
          </div>
        </div>
        <div *ngIf="isDayExpanded(day.date)" class="ops-day-group__content">
          <div class="ops-events-table-container">
            <table class="ops-events-table">
              <thead>
                <tr>
                  <th>Job</th>
                  <th>Customer</th>
                  <th>Route</th>
                  <th>Estimate<br>Signed</th>
                  <th>Paid</th>
                  <th>Weight</th>
                  <th>Calc<br>Crew</th>
                  <th>Billed<br>Crew</th>
                  <th class="ops-toggle-col" (click)="showDetails = !showDetails" pTooltip="{{ showDetails ? 'Hide' : 'Show' }} detail columns" tooltipPosition="bottom">
                    <i class="pi" [class.pi-arrow-down-left-and-arrow-up-right-to-center]="showDetails" [class.pi-arrow-up-right-and-arrow-down-left-from-center]="!showDetails"></i>
                  </th>
                  <ng-container *ngIf="showDetails">
                    <th>Calc<br>Labor</th>
                    <th>Billed<br>Labor</th>
                    <th>Calc<br>Drive</th>
                    <th>Billed<br>Drive</th>
                  </ng-container>
                  <th>Booked<br>Total</th>
                  <th>Calc<br>Total</th>
                  <th>Billed<br>Total</th>
                  <th>Notes</th>
                  <th>Inventory<br>OK</th>
                  <th>Ops<br>OK</th>
                  <th>Truck<br>OK</th>
                  <th>Crew<br>OK</th>
                  <th>Labor<br>OK</th>
                  <th>Welcome<br>OK</th>
                  <th>Revenue</th>
                  <th>Booked At</th>
                  <th>Sales Agent</th>
                  <th>Status</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let evt of day.events">
                  <td><a *ngIf="evt.jobId" class="job-code-link" href="javascript:void(0)" (click)="openJobDetails($event, evt)" (dblclick)="openJobNewTab(evt)">{{ evt.jobCode }}</a><span *ngIf="!evt.jobId">{{ evt.jobCode }}</span></td>
                  <td>{{ evt.customer }}</td>
                  <td class="ops-route-cell">
                    <ng-container *ngIf="evt.route; else unassignedRoute"><i class="pi pi-truck ops-route-icon" aria-hidden="true"></i>{{ evt.route }}</ng-container>
                    <ng-template #unassignedRoute><span class="ops-route-unassigned">Unassigned</span></ng-template>
                  </td>
                  <td class="ops-check-cell"><i *ngIf="evt.contractSigned" class="pi pi-check ops-check-yes" role="img" aria-label="Estimate signed"></i><i *ngIf="!evt.contractSigned" class="pi pi-times ops-check-no" role="img" aria-label="Estimate not signed"></i></td>
                  <td class="ops-paid-cell" [class.ops-paid-yes]="evt.jobPaidTotal && evt.jobPaidTotal !== '0' && evt.jobPaidTotal !== '$0.00'" [class.ops-paid-no]="!evt.jobPaidTotal || evt.jobPaidTotal === '0' || evt.jobPaidTotal === '$0.00'">{{ evt.jobPaidTotal && evt.jobPaidTotal !== '0' && evt.jobPaidTotal !== '$0.00' ? evt.jobPaidTotal : '\u2014' }}</td>
                  <td>{{ evt.inventoryWeight || 'None' }}<span *ngIf="evt.weightFromCalculator" class="ops-weight-est" pTooltip="Estimated weight \u2014 no inventory on file" tooltipPosition="top">*</span></td>
                  <td>{{ evt.calculatedCrewSizeDisplay }}</td>
                  <td>{{ evt.billedCrewSizeDisplay }}</td>
                  <td class="ops-toggle-col"></td>
                  <ng-container *ngIf="showDetails">
                    <td>{{ formatHours(evt.calculatedLabor) }}</td>
                    <td>{{ formatHours(evt.billedLabor) }}</td>
                    <td>{{ formatHours(evt.accurateDrive) }}</td>
                    <td>{{ formatHours(evt.billedDrive) }}</td>
                  </ng-container>
                  <td>{{ formatHours(evt.bookedTotal) }}</td>
                  <td class="ops-total-cell">
                    <span class="ops-total-value">{{ formatHours(evt.calculatedTotal) }}</span>
                    <span class="ops-diff-line" [ngClass]="diffClass(evt.calculatedDiff)">{{ formatDiff(evt.calculatedDiff) }}</span>
                  </td>
                  <td class="ops-total-cell">
                    <span class="ops-total-value">{{ formatHours(evt.billedTotal) }}</span>
                    <span class="ops-diff-line" [ngClass]="diffClass(evt.billedDiff)">{{ formatDiff(evt.billedDiff) }}</span>
                  </td>
                  <td class="ops-notes-cell"><input pInputText type="text" [(ngModel)]="evt.opsNotes" (input)="onOpsNotesInput(evt)" class="ops-notes-input" placeholder="Notes" /></td>
                  <td class="ops-check-cell"><p-checkbox [(ngModel)]="evt.inventoryOk" [binary]="true" (onChange)="toggleInventoryOk(evt, evt.inventoryOk)" ariaLabel="Inventory OK"></p-checkbox></td>
                  <td class="ops-check-cell"><p-checkbox [(ngModel)]="evt.opsApproved" [binary]="true" (onChange)="toggleOpsApproved(evt, evt.opsApproved)" ariaLabel="Ops OK"></p-checkbox></td>
                  <td class="ops-check-cell"><p-checkbox [(ngModel)]="evt.truckOk" [binary]="true" (onChange)="toggleTruckOk(evt, evt.truckOk)" ariaLabel="Truck OK"></p-checkbox></td>
                  <td class="ops-check-cell"><p-checkbox [(ngModel)]="evt.crewOk" [binary]="true" (onChange)="toggleCrewOk(evt, evt.crewOk)" ariaLabel="Crew OK"></p-checkbox></td>
                  <td class="ops-check-cell"><p-checkbox [(ngModel)]="evt.laborOk" [binary]="true" (onChange)="toggleLaborOk(evt, evt.laborOk)" ariaLabel="Labor OK"></p-checkbox></td>
                  <td class="ops-check-cell"><p-checkbox [(ngModel)]="evt.welcomeOk" [binary]="true" (onChange)="toggleWelcomeOk(evt, evt.welcomeOk)" ariaLabel="Welcome OK"></p-checkbox></td>
                  <td>{{ evt.discountedSubTotal }}</td>
                  <td>{{ evt.eventBookedStatusDate }}</td>
                  <td>{{ evt.salesAgent }}</td>
                  <td><span class="ops-status ops-status-{{ evt.eventStatus | lowercase }}">{{ evt.eventStatus }}</span></td>
                  <td>{{ evt.eventType }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>